export default __webpack_public_path__ + "static/media/1815.1c9626e7.png";